import { Injectable } from '@angular/core';
import {Headers, RequestOptions} from '@angular/http';

@Injectable()
export class BulkInfohashV2TitlesService { }


// WEBPACK FOOTER //
// ./src/app/bulkinfohash-v2/bulk-infohash-v2-search/bulk-infohash-v2-titles.service.ts